module.exports = __webpack_public_path__ + "img/cwpc-logo.41fd072f.png";